import { get_env } from '../../config/functions/app_functions';
import { BuildStagesEnum } from '../../enums/build';

const stageBuildStagesId: Record<string, BuildStagesEnum> = {
  'fb0a28f2-9a50-41ca-b91a-aa11dbb2a1f0': BuildStagesEnum.IDEA,
  '9e267aee-0fdc-458f-a327-3048a88fd81f': BuildStagesEnum.BUILD,
  '0b3f666d-6d8f-4198-9621-962cfe703a88': BuildStagesEnum.LAUNCH,
  'c73dd5fe-6a3e-4e24-a2d9-c30824a1dfb1': BuildStagesEnum.ALL,
};

const productionBuildStagesId: Record<string, BuildStagesEnum> = {
  '8924fccc-1cdd-473d-9209-4c253bf54ea4': BuildStagesEnum.IDEA,
  'a694ea72-9ced-4433-835b-741b86653989': BuildStagesEnum.BUILD,
  'e261b1f0-3e86-4b28-849b-50aeb1b35f77': BuildStagesEnum.LAUNCH,
  '18d15dfa-1289-4a91-b0bc-70c5c5a30aa9': BuildStagesEnum.ALL,
};

export const BuildStageId = get_env() === 'production' ? productionBuildStagesId : stageBuildStagesId;
